import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteGenerationSalesMaster,
  listGenerationSalesMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電販売計画マスタ 削除 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listGenerationSalesMasters を invalidate してテーブルを最新化する。
 */
export function useDeleteGenerationSalesMaster(): InvalidatingMutationResultFor<
  typeof deleteGenerationSalesMaster
> {
  return useInvalidatingMutation(deleteGenerationSalesMaster, [
    createConnectQueryKey({
      schema: listGenerationSalesMasters,
      cardinality: 'finite',
    }),
  ])
}
